var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioPlayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.6748 14.3193C3.05078 14.3193 3.3623 14.1797 3.72754 13.9648L13.3955 8.40039C14.1797 7.93848 14.4375 7.64844 14.4375 7.16504C14.4375 6.68164 14.1797 6.3916 13.3955 5.92969L3.72754 0.365234C3.3623 0.150391 3.05078 0.0107422 2.6748 0.0107422C1.99805 0.0107422 1.5791 0.537109 1.5791 1.33203V12.998C1.5791 13.793 1.99805 14.3193 2.6748 14.3193Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioPlayIcon);
export default __webpack_public_path__ + "static/media/audio_play_icon.f77b429bb8d3f46f3a914c039f1e66e6.svg";
export { ForwardRef as ReactComponent };